import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  Input,
  Col,
  Row,
  FormGroup,
  Label,
  Button,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { labelizeNamedData, patch4Select } from "@/shared/helpers";
import {
  useDispatch,
  sendFlashMessage,
  flashError,
  flashSuccess,
} from "@/shared/components/flash";
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage";
import { getLeaderboardTypes } from "@/services/program/getLeaderboardTypes";
import renderToggleButtonField from "@/shared/components/form/ToggleButton";
import renderSelectField from "@/shared/components/form/Select";
import LeaderboardEventsTable from "./LeaderboardEventsTable";
import { useTranslation } from "react-i18next";
import LeaderboardGoalPlansTable from "@/containers/Manager/ProgramSettings/components/LeaderboardGoalPlansTable";
import SaveHierarchyModal from "./SaveHierarchyModal";
import { makeFormData } from "./common";
import SelectProgramModal from "./SelectProgramModal";
import DatePicker from "react-datepicker";

const LeaderboardForm = ({
  organization,
  program,
  data,
  rtl,
  theme,
  toggle,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [leaderboardTypes, setLeaderboardTypes] = useState([]);
  let [leaderboard, setLeaderboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);
//   const [oneLeaderBoard, setOneLeaderBoard] = useState(false);

//   const onChangeOneLeaderboard = () => {
//     setOneLeaderBoard(!oneLeaderBoard);
//   };

  const setLeaderboardTypeNames = (items) => {
    let newData = [];
    let str = "";

    items.forEach((element) => {
      switch (element.name) {
        case "Event Volume":
          str = `# of Awards Received`;
          break;

        case "Event Summary":
          str = `Total Points Awarded`;
          break;

        default:
          str = "Goal Progress";
          break;
      }
      newData.push({ label: String(str), value: String(element.id) });
    });

    return newData;
  };
  const [hierarchyListData, setHierarchyListData] = useState([]);
  const [hierarchyListDataResult, setHierarchyListDataResult] = useState([]);
  const [isOpenHierarchy, setIsOpenHierarchy] = useState(false);
  const [isOpenHierarchyList, setOpenHierarchyList] = useState(false);
  const [isOpenHierarchyResult, setOpenHierarchyResult] = useState(false);
  const [checkedState, setCheckedState] = useState([]);

  const toggleHierarchy = (values) => {
    setIsOpenHierarchy((prevState) => !prevState);
  };

  const toggleHierarchyList = () => {
    const isHierarchyListOpen = isOpenHierarchyList;
    setOpenHierarchyList((prevState) => !prevState);
    if (isHierarchyListOpen) {
      toggleHierarchy();
    }
  };

  const toggleHierarchyResult = () => {
    const isOpen = isOpenHierarchyResult;
    setOpenHierarchyResult((prevState) => !prevState);
    // Closing Event Form
    if (isOpen) {
      toggle(null, true);
    }
  };
  const [leaderboardFormValues, setLeaderboardFormData] = useState(null);

  const onSubmit = (values) => {
    if (leaderboard?.id) {
      // Show Hierarchy Dialog on update event
      setLeaderboardFormData({
        ...values,
        start_date: values.start_date
          ? values.start_date.toISOString().split("T")[0]
          : null,
        end_date: values.end_date
          ? values.end_date.toISOString().split("T")[0]
          : null,
      });
      setIsOpenHierarchy(true);
    } else {
      let formData = {};

      formData["leaderboard_type_id"] = values.leaderboard_type_id.value;
      formData["name"] = values.name;
      formData["one_leaderboard"] = values.one_leaderboard;
      formData["visible"] = values?.visible ? true : false;
      formData["enable"] = values?.enable ? true : false;
      formData["start_date"] = values.start_date
        ? values.start_date.toISOString().split("T")[0]
        : null;

      formData["end_date"] = values.end_date
        ? values.end_date.toISOString().split("T")[0]
        : null;

      let nLeaderboard = {
        ...leaderboard,
        ...values,
      };
      setLeaderboard(nLeaderboard);

      setLoading(true);
      axios
        .put(
          `/organization/${organization.id}/program/${program.id}/leaderboard/${leaderboard.id}`,
          formData
        )
        .then((res) => {
          if (res.status == 200) {
            dispatch(
              sendFlashMessage(
                "Leaderboard updated successfully!",
                "alert-success",
                "top"
              )
            );
            setLoading(false);
            toggle(null, true);
          }
        })
        .catch((err) => {
          dispatch(
            sendFlashMessage(
              <ApiErrorMessage errors={err.response.data} />,
              "alert-danger",
              "top"
            )
          );
          setLoading(false);
        });
    }
  };

  const onSubmitOnlyProgram = () => {
    let data = makeFormData(program, leaderboardFormValues);
    let url = `/organization/${program.organization_id}/program/${
      leaderboardFormValues.program_id
        ? leaderboardFormValues.program_id
        : program.id
    }/leaderboard`;
    let method = "post";

    if (leaderboard?.id) {
      //Is Edit
      url += `/${leaderboard.id}`;
      method = "put";
    }
    createOrUpdateEventApiCall(data, url, method);
  };

  const onSubmitHierarchy = () => {
    let data = makeFormData(program, leaderboardFormValues);
    let url = `/organization/${program.organization_id}/program/${
      leaderboardFormValues.program_id
        ? leaderboardFormValues.program_id
        : program.id
    }/leaderboard`;
    let method = "post";

    let isHierarchyData = false;
    if (leaderboard?.id) {
      //Is Edit
      url += `/${leaderboard.id}/hierarchy-prepare?excludeArchived=true`;
      method = "put";
      isHierarchyData = true;
    }
    createOrUpdateEventApiCall(data, url, method, isHierarchyData);
  };

  const createOrUpdateEventApiCall = (
    data,
    url,
    method,
    isHierarchy = false
  ) => {
    setLoading(true);
    axios({ url, method, data })
      .then((res) => {
        if (res.status == 200) {
          if (isHierarchy) {
            const tmpCheckedState = [];
            res.data.map((item) => {
              tmpCheckedState.push({ checked: true, value: item.id });
            });
            setCheckedState(tmpCheckedState);
            setHierarchyListData(res.data);
            toggleHierarchyList();
            setLoading(false);
          } else {
            flashSuccess(dispatch, "Leaderboard saved successfully!");
            setLoading(false);
            toggle(null, true);
          }
        }
      })
      .catch((err) => {
        flashError(dispatch, err.response.data);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (data?.id) {
      setLeaderboard(data);
    }
    if (program?.id) {
      getLeaderboardTypes(organization.id, program.id).then((types) => {
        setLeaderboardTypes(labelizeNamedData(types));
        setLoading(false);
      });
    }
  }, [data, program]);

  if (!leaderboard) return t("loading");

  leaderboard = patch4Select(
    leaderboard,
    "leaderboard_type_id",
    leaderboardTypes
  );
  leaderboard.enable = leaderboard.status.status == "Active" ? true : false;

  if (leaderboard?.start_date) {
    leaderboard.start_date = new Date(leaderboard.start_date);
  }

  if (leaderboard?.end_date) {
    leaderboard.end_date = new Date(leaderboard.end_date);
  }

  const onSubmitHierarchyList = () => {
    const leaderboardData = makeFormData(program, leaderboardFormValues);
    const programIds = [];
    checkedState.map((item) => {
      if (item.checked) {
        programIds.push(item.value);
      }
    });
    leaderboardData.programIds = programIds;

    axios
      .put(
        `/organization/${program.organization_id}/program/${program.id}/leaderboard/${leaderboard.id}/hierarchy?excludeArchived=true`,
        leaderboardData
      )
      .then((res) => {
        if (res.status == 200) {
          setHierarchyListDataResult(res.data);
          setLoading(false);
          toggleHierarchyResult();
          toggleHierarchyList();
          flashSuccess(dispatch, "Leaderboard saved successfully!");
        }
      })
      .catch((err) => {
        flashError(dispatch, err.response.data);
        setLoading(false);
        toggleHierarchyList();
      });
  };

  return (
    <>
      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={{
            ...leaderboard,
            visible: leaderboard?.visible ?? false,
            enable: leaderboard?.enable ?? false,
            
        }}
        
        keepDirtyOnReinitialize
        >
        {({ handleSubmit, form, submitting, pristine, values }) => (
          <form
            className="form d-flex flex-column justify-content-evenly"
            onSubmit={handleSubmit}
          >
            <Card className="w-100 manager-program-settings-card--allow-overflow">
              <CardHeader tag="h5" className="text-center">
                Leaderboard Information
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="6">
                    <Label>Leaderboard Name</Label>
                  </Col>
                  <Col md="6">
                    <Field name="name">
                      {({ input, meta }) => (
                        <FormGroup>
                          <Input
                            placeholder="Leaderboard Name"
                            type="text"
                            {...input}
                          />
                          {meta.touched && meta.error && (
                            <span className="text-danger">{meta.error}</span>
                          )}
                        </FormGroup>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Label>Leaderboard Type</Label>
                  </Col>
                  <Col md="6">
                    <Field
                      name="leaderboard_type_id"
                      className="react-select"
                      options={leaderboardTypes}
                      placeholder={"Select Event Type"}
                      component={renderSelectField}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="6">
                    <Label>Start Date</Label>
                  </Col>
                  <Col md="6">
                    <Field name="start_date">
                      {({ input, meta }) => (
                        <FormGroup>
                          <DatePicker
                            selected={input.value || null}
                            onChange={date => input.onChange(date)}
                            minDate={new Date()}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            placeholderText="Select start date"
                            popperClassName="manager-program-settings-modal__datepicker-popper"
                            popperProps={{ strategy: "fixed" }}
                          />
                          {meta.touched && meta.error && (
                            <span className="text-danger">{meta.error}</span>
                          )}
                        </FormGroup>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Label>End Date</Label>
                  </Col>
                  <Col md="6">
                    <Field name="end_date">
                      {({ input, meta }) => (
                        <FormGroup>
                          <DatePicker
                            selected={input.value || null}
                            onChange={date => input.onChange(date)}
                            minDate={values.start_date || new Date()}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            placeholderText="Select end date"
                            popperClassName="manager-program-settings-modal__datepicker-popper"
                            popperProps={{ strategy: "fixed" }}
                          />
                          {meta.touched && meta.error && (
                            <span className="text-danger">{meta.error}</span>
                          )}
                        </FormGroup>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Label>Enable This Leaderboard</Label>
                  </Col>
                  <Col md="6">
                    <FormGroup className="d-flex justify-content-between">
                      <Field
                        name="enable"
                        component={renderToggleButtonField}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Label>Visible</Label>
                  </Col>
                  <Col md="6">
                    <FormGroup className="d-flex justify-content-between">
                      <Field
                        name="visible"
                        component={renderToggleButtonField}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {!!program.use_one_leaderboard && !program.parent_id && (
                  <Row>
                    <Col md="6">
                      <Label>Share Leaderboard</Label>
                    </Col>
                    <Col md="6">
                      <FormGroup className="d-flex justify-content-between">
                        <Field
                          name="one_leaderboard"
                          component={renderToggleButtonField}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>

            {values.one_leaderboard == true && (
              <div>
                Note: If the leaderboard is mentioned as one leaderboard, It
                will get details of all the awards. None of the associated event
                will be considered.
              </div>
            )}

            {/*goal progress*/}
            {leaderboard?.leaderboard_type_id?.value !== "3" && (
              <div className={!values.one_leaderboard ? "" : "none"}>
                <Card className="w-100">
                  <CardHeader tag="h5" className="text-center">
                    Assigned Events
                  </CardHeader>
                  <CardBody>
                    <LeaderboardEventsTable
                      leaderboard={leaderboard}
                      organization={organization}
                      program={program}
                      assigned={true}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                  </CardBody>
                </Card>
                <Card className="w-100">
                  <CardHeader tag="h5" className="text-center">
                    Unassigned Events
                  </CardHeader>
                  <CardBody>
                    <LeaderboardEventsTable
                      leaderboard={leaderboard}
                      organization={organization}
                      program={program}
                      assigned={false}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                  </CardBody>
                </Card>
              </div>
            )}

            {leaderboard?.leaderboard_type_id?.value === "3" && (
              <div className={!values.one_leaderboard ? "" : "none"}>
                <Card className="w-100">
                  <CardHeader tag="h5" className="text-center">
                    Assigned Goal Plans
                  </CardHeader>
                  <CardBody>
                    <LeaderboardGoalPlansTable
                      leaderboard={leaderboard}
                      organization={organization}
                      program={program}
                      assigned={true}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                  </CardBody>
                </Card>
                <Card className="w-100">
                  <CardHeader tag="h5" className="text-center">
                    Unassigned Goal Plans
                  </CardHeader>
                  <CardBody>
                    <LeaderboardGoalPlansTable
                      leaderboard={leaderboard}
                      organization={organization}
                      program={program}
                      assigned={false}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                  </CardBody>
                </Card>
              </div>
            )}

            <div className="d-flex justify-content-end mt-4">
              <Button disabled={loading} color="danger" type="submit">
                {"Save"}
              </Button>
            </div>
          </form>
        )}
      </Form>

      <SaveHierarchyModal
        isOpenHierarchy={isOpenHierarchy}
        toggleHierarchy={toggleHierarchy}
        onSubmitOnlyProgram={onSubmitOnlyProgram}
        onSubmitHierarchy={onSubmitHierarchy}
      />
      <SelectProgramModal
        toggleHierarchyList={toggleHierarchyList}
        onSubmitHierarchyList={onSubmitHierarchyList}
        toggleHierarchyResult={toggleHierarchyResult}
        setCheckedState={setCheckedState}
        isOpenHierarchyList={isOpenHierarchyList}
        hierarchyListData={hierarchyListData}
        checkedState={checkedState}
        programId={program?.id}
        isOpenHierarchyResult={isOpenHierarchyResult}
        hierarchyListDataResult={hierarchyListDataResult}
      />
    </>
  );
};

const validate = (values) => {
  let errors = {};
  if (!values.name) {
    errors.name = "Please enter leaderboard name";
  }
  if (!values.leaderboard_type_id) {
    errors.leaderboard_type_id = "Please select leaderboard type";
  }
  if (values.start_date && values.end_date) {
    if (values.end_date < values.start_date) {
      errors.end_date = "End date must be after start date";
    }
  }

  return errors;
};

export default LeaderboardForm;
